import { ToastContainer, Zoom } from 'react-toastify';

import { useTheme } from '#/hooks/useTheme';

const Toastify = () => {
  const { resolvedTheme } = useTheme();

  return (
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={true}
      newestOnTop={true}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      transition={Zoom}
      theme={resolvedTheme}
    />
  );
};

export default Toastify;
